import {
  get,
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";




export const  getComplaintUserReasones = ()=>{
  const url = `${endpoints.getComplaintUserReasones}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
}
export const  getComplaintmentByAdvertReasons= ()=>{
  const url = `${endpoints.getComplaintmentByAdvertReasons}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
}



